export default __webpack_public_path__ + "static/media/logo.5445f97e.png";